// TODO: (@joshs) this should be typescript :/

import { Map } from 'immutable';

import MeetingItemHelpers from 'Shared/model_helpers/MeetingItem.helper';

export const hasSubItems = subItems => {
  return subItems.count() > 0;
};

export const isSubItem = parentId => !!parentId;

export const isActionItem = itemType => itemType === 'action_item';

export const isDiscussionTopic = itemType => itemType === 'discussion_topic';

export const getTypeHumanReadable = itemType => {
  if (isActionItem(itemType)) return 'action item';
  else return 'discussion topic';
};

export const isLinkedToAsana = asanaData => !!asanaData;

export const isLinkedToGoal = goalId => !!goalId;

export const hasAttachments = attachments => attachments.size > 0;

export const hasRecurrence = recurrence => !!recurrence;

export const hasComments = meetingItem => {
  if (!Map.isMap(meetingItem)) {
    return false;
  }
  const commentsCount = MeetingItemHelpers.getCommentsCount(meetingItem);
  return commentsCount > 0;
};

export const hasParentItem = meetingItem => {
  if (!Map.isMap(meetingItem)) {
    return false;
  }
  return Boolean(MeetingItemHelpers.getParentUuid(meetingItem));
};

const insertTempItems = (sortedKeys, tempItems, exisiting) => {
  const toReturn = sortedKeys;

  // if the item was created, let's delete any possibility of a duplicate on the temp items
  tempItems.deleteAll(exisiting.keySeq().toJS()).forEach(item => {
    const slug = MeetingItemHelpers.getUuid(item);
    const afterUuid = item.get('afterUuid');
    const afterIndex = toReturn.findIndex(i => i === afterUuid);
    if (afterIndex === -1) {
      toReturn.push(slug);
    } else {
      toReturn.splice(afterIndex + 1, 0, slug);
    }
  });
  return toReturn;
};

export const sortOnPosition = ({ items, sortKey }) => {
  if (sortKey === 'goal') return items.sortBy(item => MeetingItemHelpers.getPositionForGoalDetailPage(item));
  if (sortKey === 'workspace') return items.sortBy(item => MeetingItemHelpers.getPosition(item));
  if (sortKey === 'workspace_break_position_ties_by_updated_at')
    return items.sort((itemA, itemB) => {
      const positionA = MeetingItemHelpers.getPosition(itemA);
      const positionB = MeetingItemHelpers.getPosition(itemB);
      const updatedAtA = MeetingItemHelpers.getUpdatedAt(itemA);
      const updatedAtB = MeetingItemHelpers.getUpdatedAt(itemB);

      if (positionA > positionB) return 1;
      if (positionA < positionB) return -1;

      if (updatedAtA > updatedAtB) return -1;
      if (updatedAtA < updatedAtB) return 1;

      return 0;
    });
};

const getChildren = (slug, exisiting, temp) => {
  const children = exisiting.filter(item => MeetingItemHelpers.getParentUuid(item) === slug);
  const sortedChildren = sortOnPosition(children);
  const tempChildren = temp.filter(i => MeetingItemHelpers.getParentUuid(i) === slug);
  return insertTempItems(sortedChildren.keySeq().toJS(), tempChildren, exisiting);
};

// returns a sorted object array with a 'subItemSlubs` containing sorted children item
// example:  [{uuid: 'a', subItemSlugs: ['aa','ab','ac']}, {uuid: 'b', subItemSlugs: ['ba', 'bb', 'bc']}]
export const getSortedIndexes = (existingItems, tempItems) => {
  if (!Map.isMap(existingItems) || !Map.isMap(tempItems)) return null;

  // start by getting the existing parent items, aka - items without parent UUID
  const parentItems = existingItems.filter(item => !MeetingItemHelpers.getParentUuid(item));

  // filter on high priority - this ensures hi-pri items are always on top
  const highPriority = sortOnPosition({
    items: parentItems.filter(item => MeetingItemHelpers.getIsHighPriority(item)),
    sortKey: 'goal',
  });
  const notHighPriority = sortOnPosition({
    items: parentItems.filter(item => !MeetingItemHelpers.getIsHighPriority(item)),
    sortKey: 'goal',
  });
  const sortedItems = highPriority.merge(notHighPriority);

  // convert the parent keys to an array, and insert the top level (parent) temp items keys into the array
  const parentKeys = insertTempItems(
    sortedItems.keySeq().toJS(),
    tempItems.filter(item => !MeetingItemHelpers.getParentUuid(item)),
    existingItems
  );

  const toReturn = [];
  parentKeys.forEach(key => {
    // get the sorted children keys with temp items inserted
    const sortedChildrenKeys = getChildren(key, existingItems, tempItems);
    toReturn.push({ uuid: key, subItemSlugs: sortedChildrenKeys });
  });
  return toReturn;
};
